import backendConfig from "@/config/backend.json";

/**
 * Backend API base URL baked into the bundle at build time.
 *
 * Resolution order (first non-empty wins):
 * 1. `VITE_API_BASE_URL` — production Pages build must set this to the API origin
 * 2. `src/config/backend.json` → `apiBaseUrl`
 * 3. empty string — Vite/SQLite demo only (dev proxy or same-origin demo API)
 *
 * Production is split: the SPA is a static Pages deploy; the browser calls the
 * API origin. Do not bake a production hostname into this repo. Empty base is
 * not a production default.
 */
function resolveApiBaseUrl(): string {
	const fromEnv = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim();
	if (fromEnv) {
		return fromEnv.replace(/\/+$/, "");
	}
	const fromJson = backendConfig.apiBaseUrl?.trim() ?? "";
	return fromJson.replace(/\/+$/, "");
}

export const API_BASE_URL: string = resolveApiBaseUrl();
